export const COMING_SOON_SELL_CURRENCIES = ["btc", "eth", "bfusd"];
export const COMING_SOON_BUY_CURRENCIES = ["btc", "eth", "bfusd"];
export const CURRENCIES_AVAILABLE_TO_STAKE = ["eth"];
export const CURRENCIES_AVAILABLE_TO_BUY = ["btc", "eth", "bfusd", 'bft'];
export const CURRENCIES_AVAILABLE_TO_SELL = ["btc", "eth", "bfusd"];
export const CURRENCIES_AVAILABLE_TO_DEPOSIT = ["btc", "eth", "bfusd", 'bft'];
